module.exports = __webpack_public_path__ + "img/Jefferson.7869d225.jpg";